import React from 'react';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';
import { editorApiKey } from '../../data/Constants';
import { editorDialogStyle } from '../../css/style';

const styles = editorDialogStyle();
const editorSetting = {
  plugins: 'link image code table',
  toolbar: 'undo redo | formatselect | bold italic forecolor | alignleft aligncenter alignright',
  width: '1000px',
  height: '500px',
  resize: false,
};

const EditorDialog = (props) => {
  const {
    isDialogOpen, onCloseDialog, onEditorChangeInput, editorInitialValue,
  } = props;
  const dialogActions = [
    <Button key={1} onClick={() => onCloseDialog()}>Cancel</Button>,
    <Button key={2} onClick={() => onCloseDialog('submit')}>Submit</Button>,
  ];
  return (
    <Dialog
      maxWidth="xl"
      open={isDialogOpen}
      onClose={() => onCloseDialog()}
    >
      <DialogContent style={styles.dialogContent}>
        <Editor
          apiKey={editorApiKey}
          initialValue={editorInitialValue}
          init={editorSetting}
          onEditorChange={val => onEditorChangeInput(val)}
        />
      </DialogContent>
      <DialogActions>
        {dialogActions}
      </DialogActions>
    </Dialog>
  );
};

EditorDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func,
  onEditorChangeInput: PropTypes.func,
  editorInitialValue: PropTypes.string,
};

EditorDialog.defaultProps = {
  isDialogOpen: false,
};

export default EditorDialog;
